<div>
  <mat-dialog-content>
    <h2>{{ (mediaFile ? 'announcement.edit' : 'announcement.add') | translate }}</h2>
    <form [formGroup]="announcementForm">
      <div fxLayout="column" fxLayoutGap="8px">
        <div fxLayout="row" fxFlex="1 1 auto">
          <mat-form-field fxFlex="1 1 auto">
            <mat-label>{{ 'announcement.file' | translate }}</mat-label>
            <input matInput type="text" [value]="fileName" [readonly]="true" />
          </mat-form-field>
          <input
            type="file"
            accept="audio/wav, audio/mp3"
            #fileInput
            ng2FileSelect
            [uploader]="uploader"
            formControlName="file"
            style="display: none;"
          />
          <div fxFlex="0 0 auto">
            <button mat-button *ngIf="!(uploader?.queue?.length > 0) && !fileName" (click)="fileInput.click()" class="color-primary">
              {{ 'global.browse' | translate }}
            </button>
            <div *ngIf="uploader?.queue?.length > 0">
              <button mat-icon-button (click)="togglePlayAudio()">
                <mat-icon *ngIf="audio.paused">play_arrow</mat-icon>
                <mat-icon *ngIf="!audio.paused">stop</mat-icon>
              </button>
              <button mat-icon-button (click)="clearFile()">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            <div *ngIf="!!mediaFile">
              <button mat-icon-button *ngIf="(playing$ | async) !== mediaFile.fileName" (click)="play()">
                <mat-icon matTooltip="{{ 'announcement.play' | translate }}">play_arrow</mat-icon>
              </button>
              <button mat-icon-button *ngIf="(playing$ | async) === mediaFile.fileName" (click)="stop()">
                <mat-icon matTooltip="{{ 'announcement.stop' | translate }}">stop</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div fxLayout="row">
          <mat-form-field fxFill>
            <mat-label>{{ 'announcement.name' | translate }}</mat-label>
            <input matInput type="text" formControlName="displayName" />
          </mat-form-field>
        </div>
        <div fxLayout="row">
          <mat-form-field fxFill>
            <mat-label>{{ 'announcement.description' | translate }}</mat-label>
            <textarea matInput formControlName="description"></textarea>
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions fxLayoutAlign="end">
    <button mat-raised-button [mat-dialog-close]="false" [disabled]="uploader.isUploading">
      {{ 'global.cancel' | translate }}
    </button>
    <button
      mat-raised-button
      (click)="onConfirm()"
      color="primary"
      type="submit"
      [class.spinner]="uploader.isUploading"
      [disabled]="uploader.isUploading || announcementForm.invalid || announcementForm.pristine"
    >
      {{ 'global.confirm' | translate }}
    </button>
  </mat-dialog-actions>
</div>
